
export interface MenuItems {
  id: string,
  prefix: string,
  items: number
}


export const foodItems: MenuItems[] = [
  {
    id: "aperitif",
    prefix: "food.ap",
    items: 11
  },
  // {
  //   id: "soup",
  //   prefix: "food.soup",
  //   items: 2
  // },
  // {
  //   id: "salad",
  //   prefix: "food.salad",
  //   items: 2
  // },
  {
    id: "main",
    prefix: "food.main",
    items: 7
  },
  {
    id: "desert",
    prefix: "food.desert",
    items: 3
  },
  // {
  //   id: "drinks",
  //   prefix: "food.drinks",
  //   items: 2
  // },
]

export const drinks: MenuItems[] = [
  {
    id: "wine",
    prefix: "drink_items.wine",
    items: 2
  },
  {
    id: "wine2",
    prefix: "drink_items.wine2",
    items: 2
  },
  {
    id: "lemonade",
    prefix: "drink_items.lemonade",
    items: 2
  },
  // {
  //   id: "apero",
  //   prefix: "drink_items.apero",
  //   items: 7
  // },
  // {
  //   id: "warm",
  //   prefix: "drink_items.warm",
  //   items: 2
  // },
  // {
  //   id: "beer",
  //   prefix: "drink_items.beer",
  //   items: 2
  // },
  // {
  //   id: "soft",
  //   prefix: "drink_items.soft",
  //   items: 2
  // },
  // {
  //   id: "red_wine",
  //   prefix: "drink_items.red_wine",
  //   items: 2
  // },
  // {
  //   id: "juice",
  //   prefix: "drink_items.juice",
  //   items: 2
  // },
  // {
  //   id: "water",
  //   prefix: "drink_items.water",
  //   items: 2
  // },
]


